// @flow
import gql from "graphql-tag"
import { productItemFragment, productItemMinFragment } from "data/product/graphql/fragments"

export const reservationFragment = gql`
  fragment reservationFragment on Reservation {
    id
    start
    end
    status
    code
    productItem {
      ...productItemFragment
    }
    pricingDetail {
      currency
      cancellationFee
      cancellationFeeStartsAt
      totalDays
      totalPrice
      fullPrice
      prices
      discounts {
        percentage
        type
        detail
        limitDays
      }
      accessories {
        name
        prices
      }
    }
    details {
      shippingAddress
    }
  }
  ${productItemFragment}
`

export const reservationMinFragment = gql`
  fragment reservationMinFragment on Reservation {
    id
    start
    end
    status
    code
    productItem {
      ...productItemMinFragment
    }
  }
  ${productItemMinFragment}
`



// WEBPACK FOOTER //
// ./src/data/reservations/graphql/fragments.js